export const ROLES = {
  ADMIN: 'admin',
  USER: 'user'
};

export const ADMIN_EMAILS = [
  'mariojarrunv@gmail.com'
];

export const hasRole = (user, role) => {
  if (!user) return false;
  
  // Check in different possible locations where Auth0 might store roles
  const roles = 
    user.roles || // Direct roles array
    user[`${window.location.origin}/roles`] || // Namespaced roles
    user[`https://elaquelarre-api/roles`] || // API audience roles
    user['https://dev-8ugzhhp2v2jdsph3.us.auth0.com/roles'] || // Auth0 domain roles
    [];

  return Array.isArray(roles) && roles.includes(role);
};

export const isAdmin = (user) => {
  if (!user) return false;
  
  // Check if user's email is in admin list
  const isAdminEmail = ADMIN_EMAILS.includes(user.email);
  if (isAdminEmail) {
    console.log('Admin access granted by email:', user.email);
    return true;
  }
  
  // Check if user has admin role
  const isAdminRole = hasRole(user, ROLES.ADMIN);
  
  // Also check app_metadata for admin flag
  const hasAdminMetadata = user.app_metadata && 
    (user.app_metadata.isAdmin === true || 
     user.app_metadata.roles?.includes(ROLES.ADMIN));
  
  // Check custom namespace
  const hasCustomNamespace = user['https://kosmostudio.com/roles']?.includes(ROLES.ADMIN);
  
  console.log('Admin Check:', {
    user,
    isAdminEmail,
    isAdminRole,
    hasAdminMetadata,
    hasCustomNamespace,
    roles: user.roles,
    appMetadata: user.app_metadata,
    customNamespace: user['https://kosmostudio.com/roles']
  });
  
  return isAdminRole || hasAdminMetadata || hasCustomNamespace || isAdminEmail;
};
